<template>
    <div class="bulletin">
        <!--todo 單店的公告:name要加上店家名稱，會員中心的公告不用--->
        <navigation-bar Close :name="brandName +' '+ storeName" :location="'公告快訊'"/>

        <list-container class="main">
            <div class="no-data" v-if="bulletinList.length===0">
                <img src="@/assets/images/empty.svg">
                <p>目前沒有公告訊息喔</p>
            </div>
            <category-content
                    v-for="item in bulletinList"
                    :key="item.id" :ref="`bulletin_${item.id}`">

                <img :src="item.image" class="img-block" v-if="item.image!==''"/>
                <div class="listItem">
                    <div class="d-flex mb-2 mt-1">
                        <small class="dark font-weight-bold">
                            {{item.from}}
                        </small>
                        <small class="list-date text-right">{{ item.timestamp }}</small>
                    </div>

                    <div class="list-title">{{ item.title }}</div>

                    <div class="list-content my-3">
                        <template v-if="!item.readMore && item.content.length > 45">
                            {{ item.content.substring(0, 45) + "..." }}
                        </template>
                        <template v-else>
                            {{ item.content }}
                        </template>
                        <el-button
                                type="text"
                                class="btn-readMore"
                                @click="item.readMore = !item.readMore"
                                v-show="!item.readMore && item.content.length > 45">
                            繼續閱讀
                        </el-button>
                    </div>
                </div>
            </category-content>
        </list-container>

        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
        <toast/>
    </div>
</template>

<script>
    import CategoryContent from "@/components/category/Content.vue";
    import ListContainer from "@/components/lists/Container.vue";
    import * as mutationTypes from '@/store/mutationTypes'
    import Toast from "@/components/Toast"

    export default {
        name: "Bulletin",
        components: {
            CategoryContent,
            ListContainer,
            Toast,
        },
        data() {
            return {
                bulletinList: [],
                isLoading: false,
                storeId: this.$route.query.storeId? Number(this.$route.query.storeId) :0,            //預先傳進來的商店ID
                bulletinId: this.$route.query.itemId? Number(this.$route.query.itemId) :0,            //預先傳進來的商店ID
                brandName: '',            //
                storeName: '',            //

            };
        },
        created() {

        },
        mounted() {

            let self = this;

            self.isLoading = true;
            self.callGetStoreInfoByIdApi(self.storeId)
                .then(
                    self.callGetAnnouncementApi
                )
                .then( () => {
                    self.isLoading = false;
                })
                .catch( (error) => {
                    self.$store.commit(mutationTypes.SHOW_TOAST, error);
                });
        },
        methods: {

            /** 呼叫 取得店家資訊api */
            callGetStoreInfoByIdApi (storeId) {

                let self = this;
                self.isLoading = true;

                //取得店家資訊
                return new Promise(function(resolve, reject) {
                    if (storeId === 0) {
                        self.isLoading = false;
                        resolve();

                    } else {
                        self.$http.fetch`GetStoreInfoById${{
                            id: storeId,
                            lng: 0,
                            lat: 0,
                        }} ${json => {
                            self.isLoading = false;

                            if (self.$public.notNull(json.data)) {
                                // self.storeInfo = json.data;
                                self.brandName = json.data.brandName;
                                self.storeName = json.data.name;

                                // console.log('storeImgAry:' + self.storeImgAry);
                            }
                            resolve();
                        }}`;
                    }
                });

            },

            /** 取得公告訊息，storeId = 0 爲取得享樂遊和所有會員店家的公告  */
            callGetAnnouncementApi : function() {
                let self = this;
                return new Promise(function(resolve, reject) {

                    self.isLoading = true;

                    self.$http.fetch`GetAnnouncementList${{
                        storeId: self.storeId,
                    }} ${json => {
                        if (self.$public.notNull(json.data)) {
                            self.bulletinList = json.data.map((item) => {
                                let form = '';

                                if (self.$public.notNull(item.brandName)) {
                                    form = item.brandName;
                                }
                                if (self.$public.notNull(item.storeName)) {
                                    if (form !== '') {
                                        form = form + ` ${item.storeName}`;
                                    } else {
                                        form = item.storeName;
                                    }
                                }

                                return {
                                    id: item.id,
                                    timestamp: item.createdAt,
                                    from: form,
                                    title: item.title,
                                    subTitle: '',
                                    content: item.content,
                                    readMore: false,
                                    image: item.image,
                                }
                            });
                        }

                        self.isLoading = false;
                        if (self.bulletinId > 0) {
                            self.scroll(self.bulletinId);
                        }

                        //完畢
                        resolve();
                    }}`;
                });
            },

            /** 捲動 */
            scroll: function(id) {
                if (id !== 0) {
                    let self = this;
                    this.$nextTick(() => {
                        self.$refs[`bulletin_${id}`][0].$el.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                            inline: "nearest"
                        })
                    })
                }
            }
        },
    };
</script>
<style lang="less" scoped src="../../../less/bulletin.less"/>